export default function GroomNote({ note }) {
  return <p className="groom-note">🤵 Matt says: "{note}"</p>;
}
